import React from 'react';
import { useLocale } from '../../../../contexts/LocaleContext';
import { LINKS } from '../../../../config/links';
import './Hero.css';
import logo from '../../assets/images/logo.png';

const Hero: React.FC = () => {
  const { t } = useLocale();
  
  return (
    <section className="hero eunoia-hero">
      <div className="container">
        <div className="hero-content">
          <div className="logo-container">
            <img 
              src={logo} 
              alt="Eunoia Logo" 
              className="app-logo"
              width="200"
              height="60"
            />
          </div>
          <h1>{t('eunoiaHeading')}</h1>
          <p className="subtitle">
            {t('eunoiaDescription')}
          </p>
          <div className="cta-buttons">
            <a href={LINKS.apps.eunoia.appStores.ios} className="download-btn ios" target="_blank" rel="noopener noreferrer" onClick={(e) => {
              if (LINKS.apps.eunoia.appStores.ios === '#') {
                e.preventDefault();
                alert(t('eunoiaComingSoonIOS'));
              }
            }}>
              <i className="fab fa-apple"></i>
              <div>
                <span>{t('downloadOn')}</span>
                <span>{t('appStore')}</span>
              </div>
            </a>
            <a 
              href={LINKS.apps.eunoia.appStores.android}
              className="download-btn android" 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={(e) => {
                if (LINKS.apps.eunoia.appStores.android === '#') {
                  e.preventDefault();
                  alert(t('eunoiaComingSoonAndroid'));
                }
              }}
            >
              <i className="fab fa-google-play"></i>
              <div>
                <span>{t('getItOn')}</span>
                <span>{t('googlePlay')}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;